import React, { useState } from "react";
import "./MarathiInput.scss"; // ✅ We'll use a small CSS file instead of inline styles

export default function MarathiInput({
  value,
  onChange,
  placeholder = "नाव टाइप करा",
  hasError = false,
}) {
  const [suggestions, setSuggestions] = useState([]);
  const [highlightIndex, setHighlightIndex] = useState(-1);

  const getTransliterationSuggestions = async (text) => {
    if (!text.trim()) {
      setSuggestions([]);
      return;
    }
    try {
      const res = await fetch(
        `https://inputtools.google.com/request?text=${encodeURIComponent(
          text
        )}&itc=mr-t-i0-und&num=5&cp=0&cs=1&ie=utf-8&oe=utf-8`
      );
      const data = await res.json();
      if (data[0] === "SUCCESS") {
        setSuggestions(data[1][0][1]);
        setHighlightIndex(-1);
      } else {
        setSuggestions([]);
      }
    } catch (err) {
      console.error("Transliteration error:", err);
    }
  };

  const handleChange = async (e) => {
    const val = e.target.value;
    onChange(val);
    await getTransliterationSuggestions(val);
  };

  const applySuggestion = (s) => {
    onChange(s);
    setSuggestions([]);
    setHighlightIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (suggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightIndex((prev) =>
        prev < suggestions.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : suggestions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightIndex >= 0 && highlightIndex < suggestions.length) {
        applySuggestion(suggestions[highlightIndex]);
      }
    } else if (e.key === "Escape") {
      setSuggestions([]);
    }
  };

  return (
    <div className="marathi-input-wrapper">
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={`marathi-input-field ${hasError ? "error" : ""}`}
        style={{ border: hasError ? "1px solid #DC4C64" : "1px solid #ccc" }}
      />
      {suggestions.length > 0 && (
        <ul className="marathi-suggestion-list">
          {suggestions.map((s, i) => (
            <li
              key={i}
              onClick={() => applySuggestion(s)}
              className={i === highlightIndex ? "highlighted" : ""}
            >
              {s}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
